"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useCallback } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
export type PremiumUpgradeDialogPhase = "confirm" | "success";
type PremiumUpgradeConfirmDialogProps = {
  isSubmitting: boolean;
  onConfirm: () => void | Promise<void>;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  phase: PremiumUpgradeDialogPhase;
};
export function PremiumUpgradeConfirmDialog(t0) {
  const $ = _c(25);
  const {
    isSubmitting,
    onConfirm,
    onOpenChange,
    open,
    phase
  } = t0;
  let t1;
  if ($[0] !== isSubmitting || $[1] !== onOpenChange) {
    t1 = nextOpen => {
      if (isSubmitting && !nextOpen) {
        return;
      }
      onOpenChange(nextOpen);
    };
    $[0] = isSubmitting;
    $[1] = onOpenChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[3] !== onConfirm) {
    t2 = () => {
      onConfirm();
    };
    $[3] = onConfirm;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleConfirm = t2;
  const isSuccess = phase === "success";
  const t3 = isSuccess ? "Request received" : "Upgrade to Premium?";
  let t4;
  if ($[5] !== t3) {
    t4 = <AlertDialogTitle>{t3}</AlertDialogTitle>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isSuccess ? "A member of the Propstrata team will reach out to you shortly." : "Submit a request to upgrade your organization to Premium. A Propstrata team member will contact you to discuss next steps.";
  let t6;
  if ($[7] !== t5) {
    t6 = <AlertDialogDescription>{t5}</AlertDialogDescription>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <AlertDialogHeader>{t4}{t6}</AlertDialogHeader>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleConfirm || $[13] !== isSubmitting || $[14] !== isSuccess || $[15] !== onOpenChange) {
    t8 = <AlertDialogFooter>{isSuccess ? <AlertDialogAction onClick={() => onOpenChange(false)}>Done</AlertDialogAction> : <><AlertDialogCancel disabled={isSubmitting}>Cancel</AlertDialogCancel><Button disabled={isSubmitting} onClick={handleConfirm} type="button">{isSubmitting ? "Sending\u2026" : "Confirm"}</Button></>}</AlertDialogFooter>;
    $[12] = handleConfirm;
    $[13] = isSubmitting;
    $[14] = isSuccess;
    $[15] = onOpenChange;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isSubmitting || $[18] !== t7 || $[19] !== t8) {
    t9 = <AlertDialogContent aria-busy={isSubmitting} className="sm:max-w-md">{t7}{t8}</AlertDialogContent>;
    $[17] = isSubmitting;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleOpenChange || $[22] !== open || $[23] !== t9) {
    t10 = <AlertDialog onOpenChange={handleOpenChange} open={open}>{t9}</AlertDialog>;
    $[21] = handleOpenChange;
    $[22] = open;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}